import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import * as Constants from '../../Constant/constant';
import './Add_User.css';  // Your CSS for styling
import SearchableSelect from '../../shared/SearchableSelect';

const AddUserWithMembersHistory = () => {
  // Add User form state
  const [userData, setUserData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    password: '',
    mobile_no: '',
    role_id: '',
    library_id: '',
    aadhaar_img: null,
    user_img:null,
    status: '1', // Always activated
  });
  const [roles, setRoles] = useState([]);
  const [libraries, setLibraries] = useState([]);
  const [otp, setOtp] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);

  // Members history state
  const [membersHistoryList, setMembersHistoryList] = useState([]);
  const [loadingMembersHistory, setLoadingMembersHistory] = useState(true);
  const [errorMembersHistory, setErrorMembersHistory] = useState(null);
  const [memberTypeFilter, setMemberTypeFilter] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  // Image popup state
  const [selectedImage, setSelectedImage] = useState(null);

  // Confirmation modal state for status toggle
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [memberToToggle, setMemberToToggle] = useState(null);

  // Fetch roles, libraries, and members on mount
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [rolesResponse, librariesResponse] = await Promise.all([
          axios.get(Constants.API_PATH + '/roles_list'),
          axios.get(Constants.API_PATH + '/add_new_library_data'),
        ]);
        setRoles(rolesResponse.data);
        setLibraries(librariesResponse.data);
      } catch (error) {
        console.error('Error fetching roles or libraries:', error);
      }
    };
    fetchData();
  }, []);

  // Fetch members history when memberTypeFilter or page changes
  useEffect(() => {
    fetchMembersHistory();
  }, [memberTypeFilter]);

  const fetchMembersHistory = async () => {
    setLoadingMembersHistory(true);
    setErrorMembersHistory(null);
    try {
      const response = await fetch(`${Constants.API_PATH}/auth_employee_list`);
      if (!response.ok) throw new Error('Failed to fetch members history');
      const data = await response.json();

      // Filter by memberTypeFilter if selected
      const filteredData = memberTypeFilter
        ? data.filter((member) => member.role_id === parseInt(memberTypeFilter))
        : data;

      setMembersHistoryList(filteredData);
    } catch (error) {
      setErrorMembersHistory(error.message);
    } finally {
      setLoadingMembersHistory(false);
    }
  };

  // Pagination calculations
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = membersHistoryList.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(membersHistoryList.length / itemsPerPage);

  // OTP functions
  const sendOtp = async () => {
    if (!userData.mobile_no) {
      Swal.fire({ icon: 'error', title: 'Mobile number missing', text: 'Please enter mobile number first!', confirmButtonColor: '#7494ec' });
      return;
    }
    try {
      const res = await axios.post(`${Constants.API_PATH}/send-otp`, { mobile: userData.mobile_no });
      if (res.data.success) {
        setOtpSent(true);
        Swal.fire({ icon: 'success', title: 'OTP Sent', text: 'OTP has been sent to the mobile number.', confirmButtonColor: '#7494ec' });
      }
    } catch (error) {
      Swal.fire({ icon: 'error', title: 'Failed to Send OTP', text: 'Please try again later.', confirmButtonColor: '#7494ec' });
    }
  };

  const verifyOtp = async () => {
    if (!otp) {
      Swal.fire({ icon: 'error', title: 'OTP Missing', text: 'Please enter the OTP.', confirmButtonColor: '#7494ec' });
      return;
    }
    try {
      const res = await axios.post(`${Constants.API_PATH}/verify-otp`, { mobile: userData.mobile_no, otp: otp });
      if (res.data.success) {
        setOtpVerified(true);
        Swal.fire({ icon: 'success', title: 'OTP Verified', text: 'Mobile number verified successfully.', confirmButtonColor: '#7494ec' });
      } else {
        setOtpVerified(false);
        Swal.fire({ icon: 'error', title: 'Invalid OTP', text: res.data.message || 'Verification failed', confirmButtonColor: '#7494ec' });
      }
    } catch (error) {
      Swal.fire({ icon: 'error', title: 'Failed to verify OTP', text: 'Please try again later.', confirmButtonColor: '#7494ec' });
    }
  };

  // Add user handler
  const handleAddUser = async (e) => {
    e.preventDefault();
    // if (!otpVerified) {
    //   Swal.fire({ icon: 'error', title: 'Verify Mobile Number', text: 'Please verify mobile number with OTP.', confirmButtonColor: '#7494ec' });
    //   return;
    // }
    if (!userData.aadhaar_img) {
      Swal.fire({ icon: 'error', title: 'Missing Aadhaar Image', text: 'Please upload Aadhaar card image.', confirmButtonColor: '#7494ec' });
      return;
    }
    const formData = new FormData();
    Object.entries(userData).forEach(([key, value]) => formData.append(key, value));
    formData.append('status', '1'); // Always activated

    try {
      const res = await axios.post(`${Constants.API_PATH}/register`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      if (res.data.message?.includes('User registered successfully')) {
        Swal.fire({ icon: 'success', title: 'User Added!', text: 'The new user has been created.', confirmButtonColor: '#7494ec' });
        setUserData({
          first_name: '',
          last_name: '',
          email: '',
          password: '',
          mobile_no: '',
          role_id: '',
          library_id: '',
          aadhaar_img: null,
          user_img:null,
          status: '1',
        });
        setOtp('');
        setOtpSent(false);
        setOtpVerified(false);
        fetchMembersHistory(); // Refresh members list
      } else {
        Swal.fire({ icon: 'error', title: 'Failed', text: res.data.message || 'Please try again.', confirmButtonColor: '#7494ec' });
      }
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'Something went wrong!', text: 'Please try again later.', confirmButtonColor: '#7494ec' });
    }
  };

  // Toggle member status confirmation
  const confirmToggleMemberStatus = async () => {
    setShowConfirmation(false);
    if (!memberToToggle) return;

    const { id: memberId, status: currentStatus } = memberToToggle;
    const newStatus = currentStatus === 1 ? 0 : 1;

    try {
      const response = await fetch(`${Constants.API_PATH}/update_user_status/${memberId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ status: newStatus }),
      });
      if (!response.ok) throw new Error('Failed to update status');
      fetchMembersHistory();
    } catch (error) {
      console.error('Error updating status:', error);
      alert('Failed to update status: ' + error.message);
    }
    setMemberToToggle(null);
  };

  const cancelToggleMemberStatus = () => {
    setShowConfirmation(false);
    setMemberToToggle(null);
  };

  //const openImagePopup = (imageUrl) => setSelectedImage(imageUrl);
  const closeImagePopup = () => setSelectedImage(null);
      const openImagePopup = (img) => {
          Swal.fire({
            imageUrl: `https://libtest.jaipuriaschools.com/${img.replace(/\\/g, '/')}`,
            imageAlt: 'Aadhaar Image',
            showCloseButton: true,
            width: '600px'
          });
        };

  return (
    <div className="containernew" style={{ padding: '20px', background: '#edf3f4', minHeight: '100%' }}>
      <h2>Add New User</h2>
      <form onSubmit={handleAddUser} encType="multipart/form-data" style={{ marginBottom: 40, }}>
      <div className='row' style={{ paddingTop: '20px' }}>
      <div className='col-md-6'>
        <input
          type="text"
          placeholder="First Name"
          value={userData.first_name}
          onChange={(e) => setUserData({ ...userData, first_name: e.target.value })}
          required
          className="form-input fname"
        />
        </div>
        <div className='col-md-6'>
        <input
          type="text"
          placeholder="Last Name"
          value={userData.last_name}
          onChange={(e) => setUserData({ ...userData, last_name: e.target.value })}
          required
          className="form-input lname"
        />
        </div>
       
        </div>
        <div className='row' style={{ marginTop: '20px' }}>
        <div className='col-md-4'>
        <input
          type="email"
          placeholder="Email"
          value={userData.email}
          onChange={(e) => setUserData({ ...userData, email: e.target.value })}
          required
          className="form-input"
        />
        </div>
        <div className='col-md-4'>
        <input
          type="password"
          placeholder="Password"
          value={userData.password}
          onChange={(e) => setUserData({ ...userData, password: e.target.value })}
          required
          className="form-input"
        />
        </div>
        <div className='col-md-4'> 
        <input
          type="number"
          placeholder="Mobile Number"
          value={userData.mobile_no}
          onChange={(e) => setUserData({ ...userData, mobile_no: e.target.value })}
          required
          className="form-input"
        />    
          
        </div> 
        </div>
        
      
        {/* {!otpSent ? (
          <button type="button" onClick={sendOtp} className="btn btn-primary" style={{ marginBottom: 10 }}>
            Send OTP
          </button>
        ) : (
          <>
            <input
              type="text"
              placeholder="Enter OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              required
              className="form-input"
            />
            {!otpVerified && (
              <button type="button" onClick={verifyOtp} className="btn btn-primary" style={{ marginBottom: 10 }}>
                Verify OTP
              </button>
            )}
          </>
        )} */}
        <div className="form-group">
        <SearchableSelect
          required
          value={userData.role_id}
          onChange={(e) => setUserData({ ...userData, role_id: e.target.value })}
          options={roles.map((role) => ({ value: role.id, label: role.name || role.role_name }))}
          placeholder="Select Role"
        />


        <SearchableSelect
          required
          value={userData.library_id}
          onChange={(e) => setUserData({ ...userData, library_id: e.target.value })}
          options={libraries.map((lib) => ({ value: lib.id, label: lib.library_name }))}
          placeholder="Select Library"
        />
        </div>
        <div className="form-group">
        <label style={{ display: 'block', fontWeight: 'bold' }}>Upload Aadhaar Card Image</label>
        <input
          type="file"
          accept="image/*"
          onChange={(e) => setUserData({ ...userData, aadhaar_img: e.target.files[0] })}
          required
          
        />
        </div>
           <div className="form-group">
        <label style={{ display: 'block', fontWeight: 'bold' }}>Upload User Image</label>
        <input
          type="file"
          accept="image/*"
          onChange={(e) => setUserData({ ...userData, user_img: e.target.files[0] })}
          required
          
        />
        </div>
        <button type="submit" className="btn btn-primary">
          Add User
        </button>
      </form>

      <hr />

      <div className="members-history-section container-add-user">
        {/* <nav className="breadcrumb" style={{ marginBottom: 20 }}>
          <a href="#" className="breadcrumb-link">
            Home
          </a>{' '}
          /{' '}
          <a href="#" className="breadcrumb-link">
            Library Management
          </a>{' '}
          / <span className="breadcrumb-current">Members History</span>
        </nav> */}
        <h2 className="section-title">Members List</h2>

        {/* <div className="filter-section" style={{ marginBottom: 20 }}>
          <label htmlFor="memberType" className="form-label" style={{ marginRight: 10 }}>
            Member Type*
          </label>
          <select
            id="memberType"
            className="form-select mb-2"
           value={memberTypeFilter}
            onChange={(e) => setMemberTypeFilter(e.target.value)}
            style={{ marginRight: 10 }}
          >
            <option value="">Select Role</option>
            {roles.map((role) => (
              <option key={role.id} value={role.id}>
                {role.name || role.role_name}
              </option>
            ))}
          </select>
          <button className="btn btn-secondary" onClick={fetchMembersHistory}>
            Search History
          </button>
        </div> */}

        <div
  className="filter-section d-flex align-items-center"
  style={{ gap: '10px', marginBottom: 20 }}
>
  <label htmlFor="memberType" className="form-label mb-0" style={{ whiteSpace: 'nowrap' }}>
    Member Type*
  </label>

  <SearchableSelect
    id="memberType"
    value={memberTypeFilter}
    onChange={(e) => setMemberTypeFilter(e.target.value)}
    options={roles.map((role) => ({ value: role.id, label: role.name || role.role_name }))}
    placeholder="Select Role"
  />

  {/* <button
    className="btn btn-secondary"
    style={{ whiteSpace: 'nowrap' }}
    onClick={fetchMembersHistory}
  >
    Search History
  </button> */}
</div>

        <div className="table-responsive">
          {loadingMembersHistory ? (
            <p>Loading members history...</p>
          ) : errorMembersHistory ? (
            <p>{errorMembersHistory}</p>
          ) : (
            <table className="custom-table" style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ backgroundColor: '#1e40af', color: '#fff' }}>
                  <th style={{ padding: 10, border: '1px solid #e5e7eb' }}>Sr.No.</th>
                  <th style={{ padding: 10, border: '1px solid #e5e7eb' }}>Aadhar Image</th>
                  <th style={{ padding: 10, border: '1px solid #e5e7eb' }}>User Image</th>

                  <th style={{ padding: 10, border: '1px solid #e5e7eb' }}>First Name</th>
                  <th style={{ padding: 10, border: '1px solid #e5e7eb' }}>Last Name</th>
                  <th style={{ padding: 10, border: '1px solid #e5e7eb' }}>Email</th>
                  <th style={{ padding: 10, border: '1px solid #e5e7eb' }}>Mobile No</th>
                  <th style={{ padding: 10, border: '1px solid #e5e7eb' }}>Role Name</th>
                  <th style={{ padding: 10, border: '1px solid #e5e7eb' }}>Library Name</th>
                  <th style={{ padding: 10, border: '1px solid #e5e7eb' }}>Status</th>
                  <th style={{ padding: 10, border: '1px solid #e5e7eb' }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {currentItems.length === 0 ? (
                  <tr>
                    <td colSpan="9" style={{ textAlign: 'center', padding: 20 }}>
                      No data available in table
                    </td>
                  </tr>
                ) : (
                  currentItems.map((member, index) => {
                    const roleName = roles.find((r) => r.id === member.role_id)?.name || 'N/A';
                    const libraryName = libraries.find((l) => l.id === member.library_id)?.library_name || 'N/A';
                    return (
                      <tr key={member.id}>
                        <td style={{ padding: 10 }}>{indexOfFirstItem + index + 1}</td>
                        <td style={{ padding: 10 }}>
                          <img
                            src={`https://libtest.jaipuriaschools.com/${member.aadhaar_img}`}
                            alt="Profile"
                            className="profile-image"
                            onClick={() => openImagePopup(member.aadhaar_img)}
                            style={{ cursor: 'pointer', width: 50, height: 50, borderRadius: '50%', objectFit: 'cover' }}
                          />
                        </td>
                           <td style={{ padding: 10 }}>
                          <img
                            src={`https://libtest.jaipuriaschools.com/${member.user_img}`}
                            alt="Profile"
                            className="profile-image"
                            onClick={() => openImagePopup(member.user_img)}
                            style={{ cursor: 'pointer', width: 50, height: 50, borderRadius: '50%', objectFit: 'cover' }}
                          />
                        </td>
                        <td style={{ padding: 10 }}>{member.first_name}</td>
                        <td style={{ padding: 10 }}>{member.last_name}</td>
                        <td style={{ padding: 10 }}>{member.email}</td>
                        <td style={{ padding: 10 }}>{member.mobile_no}</td>
                        <td style={{ padding: 10 }}>{roleName}</td>
                        <td style={{ padding: 10 }}>{libraryName}</td>
                        <td style={{ padding: 10 }}>{member.status === 0 ? 'Inactive' : 'Active'}</td>
                        <td style={{ padding: 10 }}>
                          <button
                            onClick={() => {
                              setMemberToToggle(member);
                              setShowConfirmation(true);
                            }}
                            className={member.status === 1 ? 'inactive-btn' : 'activate-btn'}
                            style={{
                              padding: '5px 10px',
                              borderRadius: 4,
                              border: 'none',
                              cursor: 'pointer',
                              backgroundColor: member.status === 1 ? '#ef4444' : '#22c55e',
                              color: '#fff',
                            }}
                          >
                            {member.status === 1 ? 'Inactivate' : 'Activate'}
                          </button>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          )}
        </div>

        {/* Pagination */}
        <div className="pagination" style={{ marginTop: 20 }}>
          {[...Array(totalPages)].map((_, index) => (
            <button
              key={index + 1}
              onClick={() => setCurrentPage(index + 1)}
              className={currentPage === index + 1 ? 'active-page' : ''}
              style={{
                marginRight: 5,
                padding: '5px 10px',
                borderRadius: 4,
                border: '1px solid #ccc',
                backgroundColor: currentPage === index + 1 ? '#1e40af' : '#fff',
                color: currentPage === index + 1 ? '#fff' : '#000',
                cursor: 'pointer',
              }}
            >
              {index + 1}
            </button>
          ))}
        </div>

        {/* Confirmation Modal */}
        {showConfirmation && (
          <div className="modal-overlay" style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
            justifyContent: 'center', alignItems: 'center',
            zIndex: 1000,
          }}>
            <div style={{ backgroundColor: '#fff', padding: 20, borderRadius: 8, maxWidth: 400, width: '90%' }}>
              <h3>Confirm Status Change</h3>
              <p>Are you sure you want to {memberToToggle.status === 1 ? 'inactivate' : 'activate'} this member?</p>
              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 20 }}>
                <button onClick={cancelToggleMemberStatus} style={{ padding: '8px 16px', borderRadius: 4, border: '1px solid #ccc', cursor: 'pointer' }}>
                  Cancel
                </button>
                <button onClick={confirmToggleMemberStatus} style={{ padding: '8px 16px', borderRadius: 4, backgroundColor: '#1e40af', color: '#fff', border: 'none', cursor: 'pointer' }}>
                  Confirm
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Image Popup */}
        {selectedImage && (
          <div
            className="image-popup-overlay"
            onClick={closeImagePopup}
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0,0,0,0.7)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 1000,
              cursor: 'pointer',
            }}
          >
            <img src={selectedImage} alt="Profile Full" style={{ maxHeight: '90%', maxWidth: '90%', borderRadius: 8 }} />
          </div>
        )}
      </div>
    </div>
  );
};

export default AddUserWithMembersHistory;
